import React from 'react';
import InlineSVG from 'svg-inline-react';

import MinusIcon from '../../../../snippets/icon-minus-new.liquid';
import PlusIcon from '../../../../snippets/icon-plus-new.liquid';
import ShippingTruckIcon from '../../../../snippets/icon-shipping-truck.liquid';
import CloseIcon from '../../../../snippets/icon-close-24.liquid';
import PaypalIcon from '../../../../snippets/icon-paypal.liquid';
import AfterpayIcon from '../../../../snippets/icon-afterpay.liquid';
import ArrowIcon from '../../../../snippets/icon-dropdown.liquid';
import TrashIcon from '../../../../snippets/icon-trash.liquid';

const assets = {
  afterpay: AfterpayIcon,
  arrow: ArrowIcon,
  close: CloseIcon,
  minus: MinusIcon,
  paypal: PaypalIcon,
  plus: PlusIcon,
  'shipping-truck': ShippingTruckIcon,
  trash: TrashIcon
};

const Icon = ({ className, type, style }) => (
    <InlineSVG className={className} src={assets[type]} raw={true} style={style} />
);

export default Icon;
